import { render, staticRenderFns } from "./accordionBase.vue?vue&type=template&id=ac6ac7f0&"
import script from "./accordionBase.vue?vue&type=script&lang=js&"
export * from "./accordionBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ac6ac7f0', component.options)
    } else {
      api.reload('ac6ac7f0', component.options)
    }
    module.hot.accept("./accordionBase.vue?vue&type=template&id=ac6ac7f0&", function () {
      api.rerender('ac6ac7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/Common/Scripts/Components/accordionBase.vue"
export default component.exports